import { useEffect } from 'react';
import checkIllustration from '../../assets/inquiry1.png';
import dividerIllustration from '../../assets/inquiry2.png';
import {
  clearCart,
  getCart,
  subscribeToCart,
  updateItemQuantity,
  removeItemFromCart,
} from '../../services/cart';

const OrderSuccessPage = () => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.location.assign('/orders');
      }
    }, 3500);
    clearCart()
    return () => clearTimeout(timeout);
 
  }, []);

  return (
    <div className="inquiry-success">
      <section className="success-card">
        <div className="success-badge">
          <img src={checkIllustration} alt="Order placed" />
        </div>
        <h1>Order confirmed!</h1>
        <p>Your order has been placed successfully. You can track its status in your order history.</p>
        <img src={dividerIllustration} alt="" className="success-divider-image" />
        <p className="success-note">We&apos;ll redirect you to your orders.</p>
      </section>
    </div>
  );
};

export default OrderSuccessPage;
